import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import style from '../../IndividualTacticStyle.module.css';
import { AddToWinnerTacticPanelHeader } from './AddToWinnerTacticPanelHeader';
import { AddToWinnerTacticPanelRows } from './AddToWinnerTacticPanelRows';

export const AddToWinnerTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const qtyBasis = tradePlan.quantityBasis;
    const breakPricesArr = tradePlan.positionTactics['ADD_TO_WINNER'].breakPrices;
    const qtyBasisArr = tradePlan.positionTactics['ADD_TO_WINNER'].quantityBasisValues;
    
    if (!tradePlan?.positionTactics['ADD_TO_WINNER']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <AddToWinnerTacticPanelHeader />
            <AddToWinnerTacticPanelRows qtyBasis={qtyBasis}  qtyBasisArr={qtyBasisArr} breakPricesArr={breakPricesArr} tradePlanId={tradePlanId}/>
          </table>
        </div>
      </TabPanel>
    );
  }
);

AddToWinnerTacticPanel.tabsRole = 'TabPanel';
